import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import HotDramas from './components/HotDramas';
import CategoryShowcase from './components/CategoryShowcase';
import TopRated from './components/TopRated';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '星空影院',
    url: 'https://www.xingkongyingyuan.com',
    description: '星空影院聚合热播电视剧、高分剧集全集在线观看，韩剧在线、美剧在线、国产剧大全免费追剧，超清画质不缓冲流畅播放。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.xingkongyingyuan.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <HotDramas />
        <CategoryShowcase />
        <TopRated />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}